import React, { useEffect } from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--colorBlueGray1100);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IFrame = styled.iframe`
  width: 600px;
  height: 600px;
`;

interface Props {
  onClose: () => void;
  url: string;
}

const OverlayWebpage: React.FunctionComponent<Props> = ({ onClose, url }) => {
  useEffect(() => {
    window.postMessageBridge({
      setWebViewUrl: url,
    });
    onClose();
  }, []);

  return null; /* (
    <Wrapper onTouchStart={onClose}>
      <IFrame src={url} />
    </Wrapper>
  ); */
};

export default OverlayWebpage;
